class AnchorNavigation {
  constructor() {
    this.anchorLinks = [];
    this.sections = [];
    this.isClickScrolling = false;
    document.addEventListener("DOMContentLoaded", this.init.bind(this));
  }

  init() {
    this.setAnchorNavigation();
    this.checkShowAnchorNavigation();
    this.checkYotpoSection();
    this.assignEventToSubmit();
    this.updateImageOnVariantChange();
  }

  updateImageOnVariantChange() {
    // Select the image element
    const variantImageElement = document.getElementById('sticky-variant-image');
    if (!variantImageElement) return;

    // Listen for Shopify variant changes
    document.addEventListener('change', (event) => {
      if (event.target.matches('.variant-option')) {
        const selectedVariantId = event.target.getAttribute('variant-id');
        
        // Check if the product object is available
        if (window.product && window.product.variants) {
          const selectedVariant = window.product.variants.find(variant => variant.id == selectedVariantId);
          
          // Update the image if the selected variant has an image
          if (selectedVariant && selectedVariant.featured_image) {
            variantImageElement.src = `${selectedVariant.featured_image.src}&width=120`;
            variantImageElement.alt = selectedVariant.title;
          }
        }
      }
    });
  }
  
  assignEventToSubmit() {
    document
      .querySelector(".add-to-cart-hardcoded")
      .addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();

        const mainProductButton = document.querySelector(
          ".main-product button[type=submit]"
        );
        if (!mainProductButton) return false;

        mainProductButton.click();
      });
  }

  setAnchorNavigation() {
    this.anchorLinks = document.querySelectorAll(".sticky-anchors a");
  }

  checkShowAnchorNavigation() {
    if (!this.anchorLinks.length) return;

    this.anchorLinks.forEach((link) => {
      const nameSection = link.getAttribute("href").replace("#", "");
      const nameLower = nameSection.toLowerCase();
      if (nameLower !== "sustainability") return;

      const section = document.querySelector(".sustainability-section");
      if (!section) link.parentNode.remove();
    });
  }

  checkYotpoSection() {
    const yotpoSection = document.getElementById("yotpo-reviews-main-widget");
    if (yotpoSection) {
      yotpoSection.setAttribute("data-section-id", "reviews");
      yotpoSection.setAttribute("data-section-name", "reviews");
      this.setupSections();
    } else {
      setTimeout(this.checkYotpoSection.bind(this), 500);
    }
  }

  setupSections() {
    this.anchorLinks.forEach((link) => {
      const sectionId = link.getAttribute("href").replace("#", "");
      let section = document.querySelector(`[data-section-id="${sectionId}"]`);

      if (sectionId === "yotpo-app") {
        section = document.querySelector('[data-yotpo-instance-id="380897"]');
      }

      if (!section) {
        section = document.getElementById(sectionId);
      }

      if (section) {
        this.sections.push(section);
      }
    });

    window.addEventListener("scroll", this.onScroll.bind(this));

    this.anchorLinks.forEach((link) => {
      link.addEventListener("click", (event) => this.onClick(event, link));
    });
  }

  onScroll() {
    if (this.isClickScrolling) return;

    const scrollPosition = window.scrollY;

    this.sections.forEach((section, index) => {
      const sectionTop = section.offsetTop - 60;
      const sectionBottom = sectionTop + section.offsetHeight;

      if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
        this.setAnchorNavigation();

        this.anchorLinks.forEach((link) => link.classList.remove("active"));
        this.anchorLinks[index].classList.add("active");

        // this.anchorLinks[index].scrollIntoView({
        //   block: "nearest",
        //   inline: "center",
        //   behavior: "auto",
        // });
      }
    });
  }

  onClick(event, link) {
    event.preventDefault();

    this.isClickScrolling = true;

    this.anchorLinks.forEach((link) => link.classList.remove("active"));
    link.classList.add("active");

    const targetId = link.getAttribute("href").substring(1);
    const targetSection =
      document.querySelector(`[data-section-id="${targetId}"]`) ||
      document.getElementById(targetId);
    const offset = document.querySelector(".section-sticky-anchor-navigation")
      .offsetHeight;

    let additionalOffset = 0;
    if (targetId === "yotpo-app") {
      additionalOffset = 100;
    }

    if (!targetSection) return;

    const topPosition =
      targetSection.getBoundingClientRect().top +
      window.scrollY -
      offset -
      80 -
      additionalOffset;

    window.scrollTo({
      top: topPosition,
      behavior: "auto",
    });

    setTimeout(() => {
      this.isClickScrolling = false;
    }, 200);
  }
  
}

new AnchorNavigation();
